// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const oilSeep = defineModel({
  id: "oil-seep",
  batchId: "future",
  name: "Oil seep",
  tags: ["scenery","oil","seep","low-poly","age-of-mcp","future"],
  summary: "Crude oil seeping up. Burned for lamps and refined into tar and lubricant.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.54,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.5, 0.54, 0.1, 10), color: "#3d352c", position: [0, 0.05, 0] },
      { geometry: new THREE.CylinderGeometry(0.42, 0.46, 0.06, 10), color: "#322c25", position: [0, 0.09, 0] },
      { geometry: new THREE.CylinderGeometry(0.38, 0.38, 0.03, 12), color: "#16151a", position: [0, 0.11, 0] },
      { geometry: new THREE.SphereGeometry(0.12, 6, 4), color: "#24222a", position: [0.08, 0.11, 0.06], scale: [1, 0.6, 1] },
      { geometry: new THREE.SphereGeometry(0.08, 6, 4), color: "#16151a", position: [-0.14, 0.11, -0.08], scale: [1, 0.55, 1] },
      { geometry: new THREE.SphereGeometry(0.06, 6, 4), color: "#24222a", position: [0.16, 0.11, -0.12], scale: [1, 0.6, 1] },
      { geometry: new THREE.SphereGeometry(0.045, 6, 4), color: "#16151a", position: [-0.06, 0.11, 0.18], scale: [1, 0.6, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#473d32", position: [0.34, 0.13, 0.2], rotation: [0.2, 0.6, 0.1], scale: [1.1, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.07, 0), color: "#24222a", position: [-0.38, 0.12, -0.06], rotation: [0.3, 1.2, 0.2], scale: [1, 0.7, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#3d352c", position: [0.12, 0.12, 0.42], rotation: [0.2, 0.4, 0.3], scale: [1.1, 0.7, 1] },
      { geometry: new THREE.TetrahedronGeometry(0.06, 0), color: "#322c25", position: [-0.18, 0.12, 0.4], rotation: [0.4, 1.5, 0.3] },
    ],
  animations: [],
});
